import React, { MouseEvent } from "react";
import { Resizable } from "react-resizable";
import eventEmitter from "../../services/EventEmitter";

interface Props {
  onResize: () => void;
  width: number;
}

const stopPropagation = (event: MouseEvent) => {
  event.stopPropagation();
  event.preventDefault();
};

const onResizeStop = () => {
  eventEmitter.emit("table:re-render", null);
};

const ResizableTitle: React.FC<Props> = ({ onResize, width, ...restProps }) => {
  if (!width) {
    return <th {...restProps} />;
  }

  return (
    <Resizable
      width={width}
      height={0}
      handle={
        <button
          type="button"
          className="react-resizable-handle"
          onClick={stopPropagation}
          draggable="false"
          aria-label="resize-button"
        />
      }
      onResize={onResize}
      axis="x"
      draggableOpts={{ enableUserSelectHack: false }}
      onResizeStop={onResizeStop}
    >
      <th {...restProps} />
    </Resizable>
  );
};

export default ResizableTitle;
